<template>
  <div class="sion-persion-container all-bg">
    <div class="persion-top content-per">
      <img style="width:100%" src="../../assets/images/detailBg.png" />
      <div class="top-Info">
        <!-- 头部开始 -->
        <top-part></top-part>
        <!-- 头部结束 -->
        <!-- 个人信息开始 -->
        <info-top :userInfo="detailInfo"></info-top>
        <!-- 个人信息结束 -->
      </div>
      <!-- 会员积分部分开始 -->
      <div class="bottom-img" @click="goToInteDetail">
        <img style="width:90%" src="../../assets/images/pre_info_bottom.png" />
        <span class="bottom-num van-ellipsis">{{personalObj.point}}</span>
      </div>
      <!-- 会员积分部分结束 -->
      <!-- <div class="top-portrait">
        <img v-if="userInfo.photo" :src="userInfo.photo" alt srcset />
        <img v-else :src="portrait" alt srcset @click="openPersional" />
      </div>
      <div class="top-name">
        <span>{{userInfo.name}}</span>
      </div>
      <div class="top-userInfo">
        <div class="info department">
          <div class="text">{{userInfo.deptName}}</div>
          <p>科室</p>
        </div>
        <div class="info labour">
          <div class="text">{{userInfo.unionName}}</div>
          <p>所在工会</p>
          <div class="border"></div>
        </div>
        <div class="info phone">
          <div class="text">{{userInfo.phone}}</div>
          <p>手机号</p>
        </div>
      </div>-->
      <!-- <div class="persion-content">
        <div class="sion-card">
          <div class="card" @click="openWelfare">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/fl.png" alt srcset />
              </span>
              <span class="text">我的福利</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="openActivity">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/hd.png" alt srcset />
              </span>
              <span class="text">我的活动</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="handleOpenQuestion">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/wj.png" alt srcset />
              </span>
              <span class="text">我的问卷</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div
            class="card"
            @click="condoleList"
            v-if="userInfo.identity ==2||userInfo.identity == 3"
          >
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-condole.png" alt srcset />
              </span>
              <span class="text">慰问管理</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>

          <div class="card" @click="myCondole">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">我的慰问</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>

          <div class="card" @click="hospitalization">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">住院慰问</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="death">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">亲属去世</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="rescue">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">大病救助</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="sympathy">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">其他慰问</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="subsidy">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">困难补助</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>

          <div class="card" @click="approval">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/icon-myCondole.png" alt srcset />
              </span>
              <span class="text">我的审批</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="ibeaconCheck" v-if="userInfo.identity == 5">
          <div class="item card-left">
            <span class="icon">
              <img src="@/images/icon-myCondole.png" alt srcset>
            </span>
            <span class="text">ibeacon验证</span>
          </div>
          <div class="item card-right">
            <div>
              <i class="cubeic-arrow"></i>
            </div>
          </div>
          </div>
        </div>
        <div class="sion-card">
          <div class="card" @click="openPersonnel" v-if="userInfo.identity != 1">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/ry.png" alt srcset />
              </span>
              <span class="text">人员管理</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
          <div class="card" @click="openAccount">
            <div class="item card-left">
              <span class="icon">
                <img src="@/images/sz.png" alt srcset />
              </span>
              <span class="text">账户管理</span>
            </div>
            <div class="item card-right">
              <div>
                <i class="cubeic-arrow"></i>
              </div>
            </div>
          </div>
        </div>
      </div>-->
    </div>
    <!-- 跳转list开始 -->
    <div class="list-box">
      <item-list></item-list>
    </div>
    <!-- 跳转list结束 -->

    <el-dialog
      title="ibeacon设备验证"
      class="ibeacon-dialog"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
    >
      <div class="content">
        <div class="search" v-if="ibeaconStatus&&ibeaconStatus==' '">
          <i class="el-icon-loading"></i>
          <span>正在搜索...</span>
        </div>
        <div class="search" v-if="ibeaconStatus">
          <p>已成功搜索到ibeacon设备</p>
        </div>
        <div class="search" v-if="!ibeaconStatus">
          <p>搜索ibeacon设备失败</p>
        </div>
        <p class="tip">请注意查看电脑端ibeacon验证状态</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/ecmascript-6">
import portrait from "@/images/doctor.png";
import { mapState, mapMutations } from "vuex";
import {
  getUserInformation,
  delCookie,
  toast,
  getStaffDetails
} from "@/common/api";
import notice from "./ibeacon/notice.js";
import ibeacon from "./ibeacon/ibeaconCheck.js";
import topPart from "../../components/topPart";
import infoTop from "./components/InfoTop";
import itemList from "./components/ItemList";
export default {
  components: {
    topPart,
    infoTop,
    itemList
  },
  data() {
    return {
      portrait: portrait,
      userInfo: {},
      detailInfo: {}, //修改过后的人员信息
      personalObj: {},
      dialogVisible: false,
      ibeaconNum: "",
      ibeaconStatus: "",
      pointAll: ""
    };
  },
  mounted() {
    notice.$on("getIbeaconStatus", data => {
      //接收消息
      console.log("data", data);
      if (data.errMsg) {
        this.ibeaconStatus = false;
      }
      if (data.code == 200) {
        this.ibeaconStatus = true;
      }
    });
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.pointAll = localStorage.getItem("point");
    this.replayGetDate(this.userInfo.id);
    this.getIntegral();

    let id = JSON.parse(window.localStorage.getItem("loginInfo")).id || "";
    getUserInformation({
      id: id
    }).then(res => {
      if (res.code == 200) {
        // alert(JSON.stringify(res.data));
        if (!res.data.status) {
          this.$createDialog({
            type: "alert",
            title: "提示",
            content: "登录失效,请重新登录",
            icon: "cubeic-alert",
            confirmBtn: {
              text: "退出",
              active: true,
              href: "javascript:;"
            },
            onConfirm: () => {
              window.localStorage.clear();
              delCookie("sessionId");
              this.$router.push("/login");
              window.location.reload();
            }
          }).show();
        }
      }
    });
  },
  // beforeEach(to, from, next) {
  //   alert(100);
  //   if (to.name === "login") {
  //     next({ name: "personalCenter" });
  //   } else {
  //     next(); // 注意：这边next必须要写
  //   }
  // },
  methods: {
    // 获取个人积分，名称
    getIntegral() {
      this.centralControl.axios.centralControl(
        "integralAll",
        res => {
          if (res.code == 200) {
            this.personalObj = res.data;
            // this.setIntegralAll(res.data.point);
            localStorage.setItem("integralAll", res.data.point);
          } else {
            toast(this, res.message, "error");
          }
        },
        {}
      );
    },
    replayGetDate(id) {
      // 获取会员信息
      getStaffDetails({
        id
      }).then(res => {
        if (res.code == 200) {
          console.log(res.data);
          // 根据性别展示默认头像
          if (!res.data.fileKey) {
            res.data.fileKey =
              res.data.fileKey || res.data.sex === "2"
                ? require("../../assets/images/doctor.png")
                : require("../../assets/images/male_img.png");
          }
          localStorage.setItem("detailInfo", JSON.stringify(res.data));
          this.detailInfo = JSON.parse(localStorage.getItem("detailInfo"));
        } else {
          toast(this, res.message, "error");
        }
      });
    },
    // ibeacon检测
    ibeaconCheck() {
      this.dialogVisible = true;
      ibeacon.getSignature();
      console.log("status", ibeacon);
    },
    handleClose() {
      this.dialogVisible = false;
    },
    //积分明细
    goToInteDetail() {
      this.$router.replace({
        path: "/integralDetail",
        query: {
          label: "积分明细"
        }
      });
    },
    //我的福利
    openWelfare() {
      this.$router.replace({
        path: "/home",
        query: {
          label: "节日慰问领取"
        }
      });
    },
    //我的活动
    openActivity() {
      this.$router.replace({
        path: "/home",
        query: {
          label: "工会活动"
        }
      });
    },
    // 尚
    //我的审批
    approval() {
      this.$router.push("/approval");
    },
    //住院慰问
    hospitalization() {
      this.$router.push("/hospitalization");
    },
    //亲属去世
    death() {
      this.$router.push("/death");
    },
    //大病救助
    rescue() {
      this.$router.push("/rescue");
    },
    //其他慰问
    sympathy() {
      this.$router.push("/sympathy");
    },
    //困难补助
    subsidy() {
      this.$router.push("/subsidy");
    },
    // 尚结束
    //我的问卷
    handleOpenQuestion() {
      this.$router.push("/questionList");
    },
    // 慰问管理
    condoleList() {
      this.$router.push("/condoleList");
    },
    // 我的慰问
    myCondole() {
      this.$router.push("/MyCondole");
    },
    //人员管理
    openPersonnel() {
      this.$router.push("/personnelManagement");
    },
    //账户管理
    openAccount() {
      this.$router.push("/account");
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/common.styl';

.all-bg {
  background: #fff;
  height: 100%;
}

.list-box {
  margin-top: 30px;
}

.bottom-img {
  text-align: center;
  position: absolute;
  bottom: -12px;
  width: 100%;

  .bottom-num {
    position: absolute;
    height: 21px;
    font-size: 17px;
    font-family: DIN-Medium, DIN;
    font-weight: 500;
    color: rgba(154, 114, 63, 1);
    line-height: 21px;
    top: 0;
    bottom: 0;
    margin: auto;
    right: 119px;
    display: block;
    width: 79px;
  }
}

.content-per {
  position: relative;
  // myContent();
}

.top-Info {
  position: absolute;
  top: 0;
  width: 100%;
}

.top-box {
  background: none !important;
  box-shadow: none !important;
  color: #fff;
  position: initial !important;
}

.sion-persion-container {
  .ibeacon-dialog {
    .el-dialog__header {
      text-align: center;
    }

    .content {
      .search {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .el-icon-loading {
      font-size: 26px;
    }

    .tip {
      margin: 20px 0;
      color: red;
      font-size: 12px;
      text-align: center;
    }

    .el-button--primary {
      color: #FFF;
      background-color: #38C7C4;
      border-color: #38C7C4;
    }
  }

  .persion-top {
    // height: 201px;
    // background: url('../../assets/images/detailBg.png') no-repeat center center;
    .top-portrait {
      height: 50%;
      align-items: flex-end;
      display: flex;
      justify-content: center;

      img {
        width: 56px;
      }
    }

    .top-name {
      text-align: center;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      font-size: 18px;
      margin: 0.2rem;
    }

    .top-userInfo {
      display: flex;
      color: rgba(255, 255, 255, 1);
      font-size: 15px;

      .labour {
        position: relative;

        .border {
          position: absolute;
          height: 70%;
          width: 100%;
          top: 29%;
          border-left: 1px solid rgba(255, 255, 255, 0.6);
          border-right: 1px solid rgba(255, 255, 255, 0.6);
        }
      }

      .info {
        flex: 1;

        p {
          text-align: center;
          opacity: 0.6;
        }

        .text {
          text-align: center;
          margin: 0.3rem 0;
        }
      }
    }
  }

  .persion-content {
    .sion-card {
      margin-top: 0.3rem;
      background: rgba(255, 255, 255, 1);

      .card {
        height: 49px;
        border-bottom: 1px solid #F0F0F4;
        display: flex;

        .item {
          flex: 1;
        }

        .card-right {
          display: flex;
          text-align: center;
          align-items: center;
          justify-content: flex-end;
          padding-right: 0.2rem;

          i {
            color: #E6E6E6;
            font-size: 20px;
          }
        }

        .card-left {
          display: flex;
          align-items: center;
        }

        .icon {
          display: inline-block;
          padding: 0 15px;

          img {
            width: 18px;
          }
        }

        .text {
          font-size: 15px;
          font-weight: 500;
          color: rgba(53, 53, 53, 1);
        }
      }
    }
  }
}

.cube-tab {
  div {
    padding: 0.15rem 0;
  }
}
</style>